export function getToken() {
  return window.sessionStorage.getItem('token')
}
export function setToken(tokenanduserinformation) {
  window.sessionStorage.setItem('token', tokenanduserinformation.token)
  window.sessionStorage.setItem('username', tokenanduserinformation.username)
  window.sessionStorage.setItem('userid', tokenanduserinformation.id)
}
export function removeToken() {
  window.sessionStorage.clear()
}
